require("core-js/modules/es.array.reduce.js");

var truthyPropertyClaims = function truthyPropertyClaims(propClaims) {
  var aggregate = propClaims.reduce(aggregatePerRank, {}); // on truthyness: https://www.mediawiki.org/wiki/Wikibase/Indexing/RDF_Dump_Format#Truthy_statements

  return aggregate.preferred || aggregate.normal || [];
};

var nonDeprecatedPropertyClaims = function nonDeprecatedPropertyClaims(propClaims) {
  return propClaims.filter(function (claim) {
    return claim.rank !== 'deprecated';
  });
};

var aggregatePerRank = function aggregatePerRank(aggregate, claim) {
  var rank = claim.rank;
  aggregate[rank] || (aggregate[rank] = []);
  aggregate[rank].push(claim);
  return aggregate;
};

var truthyClaims = function truthyClaims(claims) {
  var truthClaimsOnly = {};
  Object.keys(claims).forEach(function (property) {
    truthClaimsOnly[property] = truthyPropertyClaims(claims[property]);
  });
  return truthClaimsOnly;
};

module.exports = {
  truthyClaims: truthyClaims,
  truthyPropertyClaims: truthyPropertyClaims,
  nonDeprecatedPropertyClaims: nonDeprecatedPropertyClaims
};